module.exports = __webpack_public_path__ + "static/media/Compliance_FORM.d933597f.pdf";